<template>
  <div class="mx-auto mb-2" style="width: 96%">
    <div class="d-flex justify-content-between mb-2">
      <div class="d-inline-block">開始時間</div>
      <div class="d-inline-block">生產時間</div>
      <div class="d-inline-block">結束時間</div>
    </div>

    <div
      class="bar-board mx-2 d-flex align-items-center justify-content-center"
    >
      <div
        class="bar-background bar-background-first"
        style="background-color: #407a6f"
      ></div>
      <div class="bar-background" style="background-color: #4b8c80"></div>
      <div class="bar-background" style="background-color: #6fa399"></div>
      <div class="bar-background" style="background-color: #93bab3"></div>
      <div class="bar-background" style="background-color: #b7d1cc"></div>

      <div
        class="bar-background bar-background-last"
        style="background-color: #dbe8e6"
      ></div>

      <div
        class="
          mx-1
          bar-dashed
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="bar-dashed-left-text ms-1">{{ start }}</div>
        <div class="bar-dashed-middle-text">{{ runTime }}</div>
        <div class="bar-dashed-right-text me-1">{{ end }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    start: {
      type: String,
      default: "-",
    },
    runTime: {
      type: String,
      default: "-",
    },
    end: {
      type: String,
      default: "-",
    },
  },
};
</script>

<style scoped>
.bar-board {
  height: 3.5rem;
  position: relative;
}

.bar-background {
  height: 3rem;
  width: 16.6%;
}

.bar-background-first {
  font-size: 12px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.bar-background-last {
  font-size: 12px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.bar-dashed {
  height: 3.5rem;
  width: 97%;
  position: absolute;
  border-left: 2px dashed #a4a4a4;
  border-right: 2px dashed #a4a4a4;
  z-index: 1;
}

.bar-dashed-left-text {
  width: 62px;
  font-size: 12px;
  color: white;
}

.bar-dashed-middle-text {
  font-size: 1.5rem;
  color: white;
  text-shadow: 0.1em 0.1em 0.2em #212529;
}

.bar-dashed-right-text {
  width: 62px;
  font-size: 12px;
  color: black;
}
</style>